<template>
  <div
    v-if="isLoader"
    :class="$style.loaderContainer"
  >
    <loader />
  </div>
  <article
    v-else
    :class="$style.grid"
  >
    <div :class="[$style.gridItem, $style.gridItemLeft]">
      <div :class="$style.buttonsContainer">
        <button
          :class="$style.addUserButton"
          @click="getDataPack(0)"
        >
          <div :class="$style.plus">
            +
          </div>
          {{ $t('global.add') }}
        </button>
      </div>
      <div :class="$style.gridItemComputersTableContentTable">
        <dragTreeTable
          :data="listPack"
          @deleteItem="openDeleteModal"
          @saveNewName="changeName"
          @redirect="redirect"
        />
      </div>
    </div>

    <div
      v-if="isLoaderPack"
      :class="$style.loaderContainer"
    >
      <loader />
    </div>
    <div
      v-else
      :class="$style.gridItem"
    >
      <div
        v-if="selectedPack"
        :class="$style.container"
      >
        <tabset
          :tabs="tabs"
          :opened="true"
          :hide-arrow="true"
          :class="$style.tabs"
          :tab-style="tabStyle"
          @tabClick="openNewTab"
        />
        <div :class="$style.inputContainer">
          <button
            :class="[$style.save, $style.button]"
            :disabled="isNewReportPack ? !disabledBtnNewSave : !disabledBtnSave"
            @click="saveReportPack()"
          >
            {{ $t('global.save') }}
          </button>
          <div
            v-if="isNewReportPack"
            :class="$style.inputContainer"
          >
            <button
              :class="[$style.navigateBtn, $style.button]"
              :disabled="tabs[0].active"
              @click="prevTab()"
            >
              {{ $t('global.back') }}
            </button>
            <button
              :class="[$style.navigateBtn, $style.button]"
              :disabled="tabs[2].active"
              @click="nextTab()"
            >
              {{ $t('global.further') }}
            </button>
          </div>
          <button
            :class="[$style.navigateBtn, $style.button]"
            :disabled="isNewReportPack ? !disabledBtnNewSave : !disabledBtnSave"
            @click="rejectChanges()"
          >
            {{ $t('global.cancellation') }}
          </button>
        </div>
        <div
          v-if="tabs[0].active"
          :class="$style.wrapper"
        >
          <div :class="[$style.form, $style.formLeft, $style.formColumn]">
            <div :class="$style.formTitle">
              {{ $t('settings.schedule.dataSamplingInterval') }}
            </div>
            <div
              v-for="(int, index) in sampInterval"
              :key="int"
              :class="$style.formInput"
            >
              <input
                :id="`int_${int}`"
                v-model="currentInt"
                type="radio"
                :name="`int_${int}`"
                :value="index + 1"
              >
              <label :for="`int_${int}`">{{ getLabel(int) }}</label>
            </div>
            <div :class="$style.formInput">
              <input
                id="worktimeOnly"
                v-model="worktimeOnly"
                type="checkbox"
                name="worktimeOnly"
              >
              <label for="worktimeOnly">{{ $t('settings.schedule.onlyDuringBusinessHours') }}</label>
            </div>
          </div>
          <div :class="[$style.form, $style.formColumn]">
            <div :class="$style.formTitle">
              {{ $t('settings.schedule.reportTitle') }}
            </div>
            <div
              v-for="report in reportsInPack[packId]"
              :key="report.type"
              :class="$style.formInput"
            >
              <input
                :id="`report_${report.type}`"
                v-model="report.checked"
                type="checkbox"
                :name="`report_${report.type}`"
                :class="$style.checkbox"
                @click="checkedRepInPack(report)"
              >
              <label :for="`report_${report.type}`">{{ $t(`settings.schedule.reportTypes.${report.type}`) }}</label>
            </div>
          </div>
        </div>

        <div
          v-if="tabs[1].active"
          :class="$style.wrapper"
        >
          <div :class="[$style.form, $style.formLeft, $style.formColumn]">
            <dragTreeTable
              :isdraggable="false"
              :data="treeData[packId]"
              :all-checked-props="allChecked"
              @onCheckboxClick="checkedComputersInPack"
              @checkAll="checkAllComputers"
            />
          </div>

          <div :class="[$style.form, $style.formColumn]">
            <div :class="$style.formTitle">
              {{ $t('settings.schedule.frequencyOfExecution') }}
            </div>
            <div :class="[$style.configWrapper, $style.formColumn]">
              <div :class="$style.formColumn">
                <label for="startTime">{{ $t('settings.schedule.jobStartTime') }}</label>
                <input
                  id="startTime"
                  v-model="startTime"
                  type="time"
                  name="startTime"
                  step="2"
                >
              </div>
              <div :class="[$style.intervalTypes, $style.formColumn]">
                <div
                  v-for="type in intervalTypes"
                  :key="type.id"
                  :class="$style.formInput"
                >
                  <input
                    :id="`type_${type.id}`"
                    v-model="currentType"
                    type="radio"
                    :name="`type_${type.id}`"
                    :value="type.id"
                  >
                  <label :for="`type_${type.id}`">{{ type.name }}</label>
                </div>
              </div>
              <div
                v-if="isWeekType"
                :class="$style.daysWeek"
              >
                <div
                  v-for="(day, index) in daysWeek[packId]"
                  :key="day.id"
                  :style="getGridArea(index)"
                  :class="$style.formInput"
                >
                  <input
                    :id="`day_${day.id}`"
                    v-model="day.checked"
                    type="checkbox"
                    :name="`day_${day.id}`"
                    :value="day.id"
                    @click="checkedDaysWeekInPack(day)"
                  >
                  <label :for="`day_${day.id}`">{{ day.name }}</label>
                </div>
              </div>
              <div v-else-if="isMonthType">
                <label for="dayMonth">{{ $t('settings.schedule.everyone') }}</label>
                <input
                  id="dayMonth"
                  v-model="dayMonth"
                  type="number"
                  name="dayMonth"
                  min="0"
                  max="31"
                  step="1"
                  :class="$style.dayInput"
                  @input="handleDayMonthFormmater"
                >
                <label for="dayMonth">{{ $t('settings.schedule.daysOfTheMonth') }}</label>
              </div>
              <div :class="$style.formColumn">
                <label for="filterApp">{{ $t('settings.schedule.filterApp') }}</label>
                <input
                  id="filterApp"
                  v-model="filterApp"
                  type="text"
                  name="filterApp"
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="tabs[2].active"
          :class="$style.wrapper"
        >
          <div :class="[$style.form, $style.formColumn]">
            <div :class="$style.formTitle">
              {{ $t('settings.schedule.exportReportInFormat') }}
            </div>

            <div
              v-for="format in formatValues[packId]"
              :key="format.id"
              :class="$style.formInput"
            >
              <input
                :id="`format_${format.id}`"
                v-model="format.checked"
                type="checkbox"
                :name="`format_${format.id}`"
                :value="format.name"
                @click="checkedFormatValuesInPack(format)"
              >
              <label :for="`format_${format.id}`">{{ format.name }}</label>
            </div>
          </div>
          <div :class="[$style.form, $style.formColumn]">
            <div :class="$style.formInput">
              <input
                id="isEmail"
                v-model="isEmail[packId]"
                type="checkbox"
                name="isEmail"
                @click="checkedFormatValuesInPack({ checked: isEmail[packId], id: 5 })"
              >
              <label for="isEmail">{{ $t('settings.schedule.toSendByEmail') }}</label>
            </div>

            <div :class="[$style.emailWrapper]">
              <div :class="[$style.formInput]">
                <label for="email">{{ $t('settings.schedule.sendByEmail') }}</label>
                <input
                  id="email"
                  v-model="emailTo"
                  type="email"
                  name="email"
                  placeholder="e-mail@mail.ru"
                >
              </div>

              <div
                v-if="!isValidEmail"
                :class="$style.alert"
              >
                {{ alert }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <delete-modal
      id="deletePack"
      :class="$style.modal"
      @close="closeDeleteModal()"
      @update="removeReportPack()"
    />
  </article>
</template>

<script>
  import Tabset from '@/components/common/tabs/single-view-tabs.vue';
  import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
  import DeleteModal from '@/views/settings/schedule/modals/deleteModal.vue';
  import Loader from '@/components/common/blocks/loader.vue';

  import dayjs from 'dayjs';
  import { isNumber, isEmpty } from 'lodash';
  import { getDeepCopy } from '@/utils/deep-copy';
  import {
    getListPack,
    getListPeportInPack,
    getListCompAndFreqOfExecution,
    getDayWeek,
    getExpRepPack,
    saveRepPack,
    deleteReportPack,
    renameReportPack,
    changeRepPack,
  } from '@/api/methods/schedule';
  import { setNodeAttributes, findFolderAndGetCompIds, TYPE_ITEM } from '@/utils/node-attributes';
  import { validateEmail } from '@/helpers/methods';

  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import {
    SHEDULE_TABS,
    LIST_PACK_DATA,
    SAMPLING_INTERVAL,
    TREE_DATA,
    INTERVAL_TYPES_ID,
    INTERVAL_TYPES,
    WEEK_DAYS,
    FORMAT_VALUES,
    EMAIL_VALUE,
    NEW_REPORT_PACK,
    NEW_REPORTS_CONFIG,
    MODEL_KEY,
  } from './const';

  Vue.use(VueToast);
  export default {
    components: {
      Tabset,
      dragTreeTable,
      DeleteModal,
      Loader,
    },
    data() {
      return {
        isLoader: false,
        isLoaderPack: false,
        isNewReportPack: false,
        isChangeReportPack: false,
        readOnly: true,
        repName: '',
        userId: null,
        tabs: SHEDULE_TABS,
        activeTabIndex: 0,
        sampInterval: SAMPLING_INTERVAL,
        tabStyle: {
          fontSize: '15px',
        },
        listPack: LIST_PACK_DATA,
        initRepPack: [],
        reportsInPack: {},
        checkedReports: [],
        uncheckedReports: [],
        checkedComp: {},
        repPackConfig: {},
        initialInt: 1,
        currentInt: 1,
        initialWorktime: false,
        worktimeOnly: false,
        initListComp: [],
        treeData: {},
        checkedComputers: [],
        uncheckedComputers: [],
        initialStartTime: '',
        startTime: '',
        initCurrentType: INTERVAL_TYPES.EVERY_DAY,
        currentType: INTERVAL_TYPES.EVERY_DAY,
        intervalTypes: INTERVAL_TYPES,
        initDaysWeek: [],
        daysWeek: {},
        checkedDaysWeek: [],
        uncheckedDaysWeek: [],
        initDayMonth: 0,
        dayMonth: 0,
        initFilterApp: '',
        filterApp: '',
        initFormatValues: [],
        formatValues: {},
        checkedFormatValues: [],
        uncheckedFormatValues: [],
        initIsEmail: false,
        isEmail: {},
        initEmailTo: '',
        emailTo: '',
        alert: this.$t('settings.schedule.alert'),
        deletePack: null,
        mapFolder: {},
        compIds: {},
        computersIdsForAllChecked: {},
        computersIdsForAllUnchecked: {},
      };
    },
    computed: {
      allChecked() {
        return (
          this.checkedComputers.length === this.computersIdsForAllChecked[this.packId]?.length &&
          !this.uncheckedComputers.length
        );
      },
      reportInPackChecked() {
        return this.checkedList(this.reportsInPack[this.packId]);
      },
      compListChecked() {
        return this.checkedList(this.treeData[this.packId].lists);
      },
      formatValuesChecked() {
        return this.checkedList(this.formatValues[this.packId]);
      },
      daysWeekChecked() {
        return this.daysWeek[this.packId]?.some((item) => item.checked);
      },
      isValidEmail() {
        return validateEmail(this.emailTo);
      },
      disabledBtnNewSave() {
        const isBaseCondition = this.reportInPackChecked && this.compListChecked && this.formatValuesChecked;
        const isWeekTypeCondition = this.isWeekType ? this.daysWeekChecked : true;
        const isMonthTypeCondition = this.isMonthType ? this.dayMonth : true;
        return isBaseCondition && isWeekTypeCondition && isMonthTypeCondition;
      },
      disabledBtnSave() {
        return (
          this.currentInt !== this.initialInt ||
          this.worktimeOnly !== this.initialWorktime ||
          !!this.checkedReports.length ||
          !!this.uncheckedReports.length ||
          !!this.checkedComputers.length ||
          !!this.uncheckedComputers.length ||
          this.startTime !== this.initialStartTime ||
          this.currentType !== this.initCurrentType ||
          this.dayMonth !== this.initDayMonth ||
          !!this.checkedDaysWeek.length ||
          !!this.uncheckedDaysWeek.length ||
          this.filterApp !== this.initFilterApp ||
          !!this.checkedFormatValues.length ||
          !!this.uncheckedFormatValues.length ||
          this.isEmail[this.packId] !== this.initIsEmail ||
          this.emailTo !== this.initEmailTo
        );
      },
      isSelectedPack() {
        return (packId) => this.selectedPack && this.selectedPack.id === packId;
      },
      selectedPack() {
        const packId = +this.$route.query.packId;
        if (packId === 0) return getDeepCopy(NEW_REPORT_PACK);

        if (Number.isNaN(packId) && packId < 0 && !this.listPack.lists.length) return null;
        return this.listPack.lists.find(({ id }) => +id === +packId);
      },
      packId() {
        return +this.$route.query.packId;
      },
      isWeekType() {
        return this.currentType === INTERVAL_TYPES_ID.EVERY_WEEK;
      },
      isMonthType() {
        return this.currentType === INTERVAL_TYPES_ID.EVERY_MONTH;
      },
    },
    async created() {
      this.userId = this.$store.getters['user/userId'];
      this.isLoader = true;

      await this.fetch();
      this.isLoader = false;
    },
    async mounted() {
      this.$store.subscribeAction({
        // eslint-disable-next-line
        after: async (action, state) => {
          if (action.type === 'settings/refresh') {
            this.isChangeReportPack = true;
            await this.fetch();
            this.isChangeReportPack = false;
          }
        },
      });
    },
    methods: {
      closeDeleteModal() {
        document.getElementById('deletePack').style.display = 'none';
      },
      openDeleteModal(pack) {
        this.deletePack = pack;
        document.getElementById('deletePack').style.display = 'flex';
      },
      async fetch() {
        this.listPack.lists = await getListPack(this.userId);
        if (this.selectedPack) {
          await this.getDataPack(this.selectedPack.id);
        }
      },
      async redirect(pack) {
        if (this.disabledBtnSave) this.rejectChanges();
        if (!this.selectedPack || +this.selectedPack?.id !== +pack.id) {
          this.$router.replace({ name: 'schedule', query: { packId: pack.id } });
          await this.getDataPack(pack.id);
        }
      },
      async getDataPack(packId) {
        this.isLoaderPack = true;
        this.isNewReportPack = !packId;

        if (this.isNewReportPack) {
          const packInList = this.listPack.lists.find(({ id }) => id === packId);
          if (!packInList) {
            this.listPack.lists.unshift(getDeepCopy(NEW_REPORT_PACK));
            if (packId !== +this.$route.query.packId) {
              this.$router.replace({ name: 'schedule', query: { packId } });
            }
          }
          if (this.activeTabIndex !== 0) this.openNewTab(0);
        }
        this.repName = this.selectedPack.repName;
        this.currentInt = this.selectedPack.setInterv;
        this.initialInt = this.currentInt;

        this.filterApp = this.selectedPack.filter;
        this.initFilterApp = this.filterApp;

        if (this.isChangeReportPack || !this.reportsInPack[packId]) {
          const { reportsData, compData } = await getListPeportInPack(packId, this.userId);
          this.$set(this.reportsInPack, packId, reportsData);

          const checkedCompData = compData.filter(({ id }) => isNumber(id));
          this.$set(this.checkedComp, packId, checkedCompData);
        }
        this.initRepPack = getDeepCopy(this.reportsInPack[packId]);

        this.worktimeOnly = !!this.selectedPack.worktime;
        this.initialWorktime = this.worktimeOnly;

        const { shedId } = this.selectedPack;
        if (this.isChangeReportPack || !this.treeData[packId] || !this.repPackConfig[packId]) {
          this.checkedComputers = [];
          this.uncheckedComputers = [];
          const { reports, computers } = await getListCompAndFreqOfExecution(shedId, this.userId);

          this.$set(this.repPackConfig, packId, reports[0]);

          if (!this.treeData[packId]) {
            this.$set(this.treeData, packId, getDeepCopy(TREE_DATA));
            const computersList = computers.computers;

            if (isEmpty(this.mapFolder)) findFolderAndGetCompIds(computers.tree, this.mapFolder);

            const computerIds = this.checkedComp[packId].map(({ cid }) => cid);
            this.computersIdsForAllUnchecked[packId] = computerIds;
            if (computersList.length === computerIds.length) {
              computers.groups.forEach(({ id }) => computerIds.push(id));
            } else {
              const compIds = new Set(computerIds);
              Object.entries(this.mapFolder).forEach(([nodeId, computersInNode]) => {
                const isCheckedNode = !computersInNode.some(({ id }) => !compIds.has(id));
                if (isCheckedNode) computerIds.push(+nodeId);
              });
            }
            this.compIds[packId] = new Set(computerIds);
            this.computersIdsForAllChecked[packId] = computersList
              .filter(({ id }) => !this.compIds[packId].has(id))
              .map(({ id }) => id);
            computers.tree.forEach((item) => setNodeAttributes(item, this.compIds[packId]));

            this.$set(this.treeData[packId], 'lists', computers.tree);
          }
        }

        this.initListComp = getDeepCopy(this.treeData[packId].lists);

        const { startTime, intervType, dayMonth } = !this.isNewReportPack
          ? this.repPackConfig[packId]
          : NEW_REPORTS_CONFIG;

        this.startTime = !this.isNewReportPack ? startTime : dayjs(new Date()).format('HH:mm:ss');
        this.initialStartTime = this.startTime;

        this.currentType = intervType;
        this.initCurrentType = this.currentType;

        if (this.isChangeReportPack || !this.daysWeek[packId]) {
          this.$set(this.daysWeek, packId, getDeepCopy(WEEK_DAYS));
          if (!this.isNewReportPack) {
            const daysFromDB = await getDayWeek(shedId);
            const checkedDays = new Set(daysFromDB.map(({ mwId }) => mwId));
            this.daysWeek[packId].forEach((item) => {
              item.checked = checkedDays.has(item.id);
            });
          }
        }

        this.dayMonth = dayMonth;

        this.initDaysWeek = getDeepCopy(this.daysWeek[packId]);
        this.initDayMonth = this.dayMonth;

        this.emailTo = this.selectedPack.emailTo;
        this.initEmailTo = this.emailTo;

        if (this.isChangeReportPack || !this.formatValues[packId]) {
          this.$set(this.formatValues, packId, getDeepCopy(FORMAT_VALUES));

          const exptFromDB = await getExpRepPack(packId);
          const checkedExpt = new Set(exptFromDB.map(({ expt }) => expt));
          this.formatValues[packId].forEach((item) => {
            item.checked = checkedExpt.has(item.id);
          });
          this.$set(this.isEmail, packId, checkedExpt.has(EMAIL_VALUE));
        }
        this.initIsEmail = this.isEmail[packId];
        this.initFormatValues = getDeepCopy(this.formatValues[packId]);

        this.isLoaderPack = false;
      },

      getLabel(count) {
        if (count > 1) {
          const lastDay = count % 10;
          if (lastDay > 1 && lastDay < 5) {
            return this.$t('settings.schedule.daysOne', { count });
          }
          return this.$t('settings.schedule.daysTwo', { count });
        }
        return this.$t('settings.schedule.oneDay', { count });
      },
      getGridArea(index) {
        return {
          'grid-area': `area${index + 1}`,
        };
      },
      checkedList(list) {
        return list?.some((item) => {
          if (item?.type === TYPE_ITEM.FOLDER) {
            this.checkedList(item.children);
          }
          return item.checked;
        });
      },
      handleDayMonthFormmater(event) {
        let value = parseInt(event.target.value, 10);
        if (Number.isNaN(value) || value < 0) value = 0;
        if (value > 31) value = 31;
        this.dayMonth = value;
      },
      getMessage(message, type = 'info') {
        Vue.$toast.open({
          message,
          type,
          duration: 6000,
        });
      },
      nextTab() {
        if (this.activeTabIndex === 0) this.openNewTab(1);
        else if (this.activeTabIndex === 1) this.openNewTab(2);
      },
      prevTab() {
        if (this.activeTabIndex === 1) this.openNewTab(0);
        if (this.activeTabIndex === 2) this.openNewTab(1);
      },
      openNewTab(index) {
        if (this.isNewReportPack && index > this.activeTabIndex) {
          if (this.activeTabIndex === 0 && !this.reportInPackChecked) {
            return this.getMessage(this.$t('settings.schedule.selectReports'));
          }
          if (this.activeTabIndex === 1 && !this.compListChecked) {
            return this.getMessage(this.$t('settings.schedule.selectUsers'));
          }
          if (this.activeTabIndex === 1 && this.isWeekType && !this.daysWeekChecked) {
            return this.getMessage(this.$t('settings.schedule.selectWeekDays'));
          }
          if (this.activeTabIndex === 1 && this.isMonthType && !this.dayMonth) {
            return this.getMessage(this.$t('settings.schedule.selectMonthDay'));
          }
        }
        this.tabs.forEach((item) => {
          item.active = false;
        });

        this.tabs[index].active = true;
        this.activeTabIndex = index;
        return index;
      },
      rejectChanges() {
        if (this.activeTabIndex === 0) {
          this.currentInt = this.isNewReportPack ? 1 : this.initialInt;
          this.worktimeOnly = this.isNewReportPack ? false : this.initialWorktime;

          this.reportsInPack[this.packId] = getDeepCopy(this.initRepPack);

          this.checkedReports = [];
          this.uncheckedReports = [];
        }
        if (this.activeTabIndex === 1) {
          this.treeData[this.packId].lists = getDeepCopy(this.initListComp);

          this.checkedComputers = [];
          this.uncheckedComputers = [];

          this.startTime = this.initialStartTime;
          this.currentType = this.initCurrentType;

          if (this.isWeekType) this.daysWeek[this.packId] = getDeepCopy(this.initDaysWeek);

          this.checkedDaysWeek = [];
          this.uncheckedDaysWeek = [];

          if (this.isMonthType) this.dayMonth = this.initDayMonth;

          this.filterApp = this.initFilterApp;
        }
        if (this.activeTabIndex === 2) {
          this.formatValues[this.packId] = getDeepCopy(this.initFormatValues);
          this.isEmail[this.packId] = this.initIsEmail;
          this.emailTo = this.initEmailTo;
        }
      },
      async saveReportPack() {
        try {
          if (this.isEmail[this.packId] && (!this.emailTo || !this.isValidEmail)) {
            return this.getMessage(this.$t('settings.schedule.fillEmail'));
          }
          let result;
          this.isLoaderPack = true;

          if (this.isNewReportPack) {
            result = await this.saveNewReportPack();
          } else {
            result = await this.changeReportPack();
          }
          return this.getMessage(result.message, result.typeMsg);
        } catch (error) {
          console.error(this.$t('settings.schedule.savePackageError'), error);
          return { message: this.$t('settings.schedule.savePackageError'), typeMsg: 'error' };
        } finally {
          this.isLoaderPack = false;
        }
      },
      async saveNewReportPack() {
        try {
          this.isLoaderPack = true;

          const params = {
            startTime: this.startTime,
            intervType: this.currentType,
            dayMonth: this.dayMonth,
            daysWeek: this.checkedDaysWeek,
            repName: this.repName,
            currentInt: this.currentInt,
            userId: this.userId,
            emailTo: this.emailTo,
            worktime: this.worktimeOnly,
            filterApp: this.filterApp,
            repInPack: this.checkedReports,
            computersArray: this.checkedComputers,
            formatValues: this.checkedFormatValues,
          };

          const { packId } = await saveRepPack(params);

          this.$router.replace({ name: 'schedule', query: { packId } });
          await this.fetch();
          return { message: this.$t('settings.schedule.packageCreated'), typeMsg: 'success' };
        } catch (error) {
          console.error(this.$t('settings.schedule.createPackageError'), error);
          return { message: this.$t('settings.schedule.createPackageError'), typeMsg: 'error' };
        } finally {
          this.isLoaderPack = false;
        }
      },
      async removeReportPack() {
        try {
          this.isLoaderPack = true;
          const packId = this.deletePack.id;

          if (packId !== 0) await deleteReportPack(packId);

          this.listPack.lists = this.listPack.lists.filter(({ id }) => +id !== +packId);
          if (this.$route.query.packId) this.$router.replace({ name: 'schedule', query: null });
          this.getMessage(this.$t('settings.schedule.packageDeleted'), 'success');
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoaderPack = false;
        }
      },
      async changeName(pack) {
        if (pack.id === 0) {
          this.repName = pack.repName;
          return null;
        }
        this.isLoaderPack = true;
        await renameReportPack(pack.id, pack.repName);
        this.isLoaderPack = false;
        this.getMessage(this.$t('settings.schedule.packageNameChanged'), 'success');
        return this.repName;
      },
      setCheckboxAction(model, checkedArray, uncheckedArray, key) {
        if (!model.checked) {
          const indexUncheckArray = uncheckedArray.indexOf(model[key]);
          if (indexUncheckArray >= 0) {
            uncheckedArray.splice(indexUncheckArray, 1);
          } else {
            const indexCheckArray = checkedArray.indexOf(model[key]);
            if (indexCheckArray >= 0) {
              checkedArray.splice(indexCheckArray, 1);
            } else {
              checkedArray.push(model[key]);
            }
          }
        } else {
          const indexCheckArray = checkedArray.indexOf(model[key]);
          if (indexCheckArray >= 0) {
            checkedArray.splice(indexCheckArray, 1);
          } else {
            const indexUncheckArray = uncheckedArray.indexOf(model[key]);
            if (indexUncheckArray >= 0) {
              uncheckedArray.splice(indexUncheckArray, 1);
            } else {
              uncheckedArray.push(model[key]);
            }
          }
        }
      },
      checkedRepInPack(report) {
        this.setCheckboxAction(report, this.checkedReports, this.uncheckedReports, MODEL_KEY.TYPE);
      },

      checkedComputersInPack(computer) {
        if (computer?.type === TYPE_ITEM.FOLDER && computer?.children?.length) {
          const compIds = this.compIds[this.packId];

          this.mapFolder[computer.id].forEach((comp) => {
            if (this.checkedComputers.includes(comp.id) || this.uncheckedComputers.includes(comp.id)) {
              this.setCheckboxAction(comp, this.checkedComputers, this.uncheckedComputers, MODEL_KEY.ID);
            }
          });
          if (computer.checked) {
            const compIdsInFolder = this.mapFolder[computer.id]
              .filter((comp) => compIds.has(comp.id))
              .map(({ id }) => id);
            this.uncheckedComputers.push(...compIdsInFolder);
          } else if (!compIds.has(computer.id)) {
            const compIdsInFolder = this.mapFolder[computer.id]
              .filter((comp) => !compIds.has(comp.id))
              .map(({ id }) => id);
            this.checkedComputers.push(...compIdsInFolder);
          }
        } else {
          this.setCheckboxAction(computer, this.checkedComputers, this.uncheckedComputers, MODEL_KEY.ID);
        }
      },
      checkedDaysWeekInPack(day) {
        this.setCheckboxAction(day, this.checkedDaysWeek, this.uncheckedDaysWeek, MODEL_KEY.ID);
      },
      checkedFormatValuesInPack(format) {
        if (!format || typeof format !== 'object') return;
        this.setCheckboxAction(format, this.checkedFormatValues, this.uncheckedFormatValues, MODEL_KEY.ID);
      },
      checkAllComputers(event) {
        if (event) {
          this.checkedComputers = this.computersIdsForAllChecked[this.packId];
          this.uncheckedComputers = [];
        } else {
          this.uncheckedComputers = this.computersIdsForAllUnchecked[this.packId];
          this.checkedComputers = [];
        }
      },
      async changeReportPack() {
        if (!this.reportInPackChecked) {
          return this.getMessage(this.$t('settings.schedule.selectReports'));
        }
        if (!this.compListChecked) {
          return this.getMessage(this.$t('settings.schedule.selectUsers'));
        }
        if (this.isWeekType && !this.daysWeekChecked) {
          return this.getMessage(this.$t('settings.schedule.selectWeekDays'));
        }
        if (this.isMonthType && !this.dayMonth) {
          return this.getMessage(this.$t('settings.schedule.selectMonthDay'));
        }
        if (!this.formatValuesChecked) {
          return this.getMessage(this.$t('settings.schedule.selectReportFormat'));
        }
        try {
          this.isLoaderPack = true;
          this.isChangeReportPack = true;

          if (+this.initCurrentType === +INTERVAL_TYPES_ID.EVERY_WEEK && +this.currentType !== +this.initCurrentType) {
            this.uncheckedDaysWeek = this.initDaysWeek.filter(({ checked }) => checked).map(({ id }) => id);
            this.daysWeek[this.packId] = getDeepCopy(WEEK_DAYS);
          }

          if (this.uncheckedComputers?.length) {
            const compMap = {};
            this.checkedComp[this.packId].forEach(({ id, cid }) => {
              compMap[cid] = id;
            });
            this.uncheckedComputers = this.uncheckedComputers.map((compId) => compMap[compId]);
          }

          if (this.uncheckedReports?.length) {
            const uncheckedReportsMap = new Set(this.uncheckedReports);

            const checkedRepData = this.initRepPack.filter(({ checked }) => checked);
            const uncheckedReports = [];
            checkedRepData.forEach((report) => {
              if (uncheckedReportsMap.has(report.type)) uncheckedReports.push(report.id);
            });
            this.uncheckedReports = uncheckedReports;
          }

          const params = {
            packId: this.packId,
            shedId: this.selectedPack.shedId,
            setInt: this.currentInt !== this.initialInt ? this.currentInt : null,
            worktime: this.worktimeOnly !== this.initialWorktime ? +this.worktimeOnly : null,
            checkedReports: this.checkedReports,
            uncheckedReports: this.uncheckedReports,
            checkedComputers: this.checkedComputers,
            uncheckedComputers: this.uncheckedComputers,
            startTime: this.startTime !== this.initialStartTime ? this.startTime : null,
            intervType: this.currentType !== this.initCurrentType ? this.currentType : null,
            dayMonth: this.dayMonth !== this.initDayMonth ? this.dayMonth : null,
            checkedDaysWeek: this.checkedDaysWeek,
            uncheckedDaysWeek: this.uncheckedDaysWeek,
            filterApp: this.filterApp,
            checkedFormatValues: this.checkedFormatValues,
            uncheckedFormatValues: this.uncheckedFormatValues,
            emailTo: this.emailTo !== this.initEmailTo ? this.emailTo : null,
          };

          const data = await changeRepPack(params);
          if (data) {
            this.checkedReports = [];
            this.uncheckedReports = [];
            this.checkedComputers = [];
            this.uncheckedComputers = [];
            this.checkedDaysWeek = [];
            this.uncheckedDaysWeek = [];
            this.checkedFormatValues = [];
            this.uncheckedFormatValues = [];
          }
          await this.fetch();

          return { message: this.$t('settings.schedule.packageUpdated'), typeMsg: 'success' };
        } catch (error) {
          console.error(this.$t('settings.schedule.updatePackageError'), error);
          return { message: this.$t('settings.schedule.updatePackageError'), typeMsg: 'error' };
        } finally {
          this.isLoaderPack = false;
          this.isChangeReportPack = false;
        }
      },
    },
  };
</script>

<style lang="scss" module>
  input {
    accent-color: #2985bf;
  }

  .loaderContainer {
    height: 100%;
    width: 100%;
  }
  .buttonsContainer {
    display: inline-flex;
    width: 100%;
  }

  .addUserButton {
    border: none;
    background: #2985bf;
    cursor: pointer;
    height: 30px;
    color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .plus {
    font-weight: 500;
    font-size: 24px;
    padding: 0px 5px;
  }

  .grid {
    border-left: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    display: flex;
    background: white;
    height: 100%;
    overflow: auto;
  }

  .gridItem {
    flex-grow: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 65%;
  }

  .gridItemLeft {
    flex: 0 0 35%;
    border-right: 1px solid #e3e3e3;
  }

  .tabs {
    margin: 0 10px;
  }

  .container {
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .inputContainer {
    font-size: 13px;
    margin: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .button {
    border: 1px solid $white;
    cursor: pointer;
    color: $white;
    height: 30px;
    width: 88px;
    &:disabled {
      background: $branchColor;
      border: $branchColor;
    }
  }
  .save {
    background: $blue;
  }

  .navigateBtn {
    color: $light-black;
    background: $light-blue;
    &:disabled {
      background: $branchColor;
      border: $branchColor;
    }
  }

  .wrapper {
    display: flex;
    gap: 10px;
    margin: 0 0 15px 22px;
  }

  .form {
    font-style: normal;
    font-size: 14px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: 10px;
    flex: 2;
  }
  .formLeft {
    flex: 1;
  }

  .formColumn {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .formTitle {
    font-size: 15px;
  }
  .formInput {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 5px;
    & * {
      cursor: pointer;
    }
    & input {
      flex-shrink: 0;
      margin: 0;
    }
  }

  .emailWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .alert {
    color: $red;
  }

  .dayInput {
    width: 50px;
    margin: 0 5px;
  }

  .configWrapper {
    padding-left: 10px;
  }

  .intervalTypes {
    border: 1px solid #e3e3e3;
    padding: 5px;
  }

  .daysWeek {
    display: grid;
    grid-template-columns: repeat(2, 70px);
    grid-template-rows: repeat(4, auto);
    row-gap: 5px;
    border: 1px solid #e3e3e3;
    padding: 5px;
    grid-template-areas:
      'area1 area5'
      'area2 area6'
      'area3 area7'
      'area4 .';
  }

  .modal {
    display: none;
    z-index: 3000;
  }
</style>

<style>
  .drag-tree-table {
    margin: 0;
    color: black;
    overflow: auto;
    display: flex;
    flex-direction: column;
    min-width: 450px;
  }

  .drag-tree-table-header {
    background: #f5f5f5;
    line-height: 20px;
  }

  canvas {
    width: 100% !important;
    height: fit-content !important;
    margin: 0px !important;
  }

  .tree-column {
    text-align: left;
  }
</style>
